
import { connect } from 'react-redux';
import EnterpriseDetails from './EnterpriseDetails';
import { setProgressBarStatus } from '../../redux/actions/progressBar';

const mapStateToProps = null;

const mapDispatchToProps = {
  setProgressBarStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterpriseDetails);
